document.addEventListener("DOMContentLoaded", function () {
  // Sélectionner tous les formulaires d'ajout au panier
  const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');

  addToCartForms.forEach((form) => {
    form.addEventListener("submit", async (event) => {
      event.preventDefault();

      const formData = new FormData(form);

      const response = await fetch("/cart/add.js", {
        method: "post",
        body: formData,
      });

      if (response.ok) {
        updateCartDrawer();
        openCartDrawer();
      } else {
        console.error("Failed to add item to cart:", await response.text());
      }
    });
  });
});

function openCartDrawer() {
  const drawer = document.querySelector("cart-drawer");
  if (drawer) {
    drawer.classList.add("animate", "active");
  } else {
    console.error("cart-drawer introuvable");
  }
}


async function updateCartDrawer() {
  const response = await fetch("/?section_id=cart-drawer");
  const cartHTML = await response.text();
  const parser = new DOMParser();
  const doc = parser.parseFromString(cartHTML, "text/html");
  const newDrawer = doc.querySelector(".cart-drawer");
  const currentDrawer = document.querySelector(".cart-drawer");

  if (currentDrawer && newDrawer) {
    currentDrawer.replaceWith(newDrawer);
  }
}

//PRODUCT

document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth < 768) {
    // Initializes only on mobile
    const slider10Element = document.getElementById("slider10");
    if (slider10Element) {
      new Splide("#slider10", {
        type: "slide",
        perPage: 1,
        arrows: false,
        pagination: true,
      }).mount();
    }
  }
});

function toggleText(ingredientId) {
  const element = document.getElementById(ingredientId);
  const shortText = element.querySelector(".short-text");
  const longText = element.querySelector(".long-text");
  if (shortText.classList.contains("hidden")) {
    shortText.classList.remove("hidden");
    longText.classList.add("hidden");
    element.classList.remove("!bg-opacity-30");
  } else {
    shortText.classList.add("hidden");
    longText.classList.remove("hidden");
    element.classList.add("!bg-opacity-30");
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const mainCarousel = document.getElementById("main-carousel");
  const thumbnailCarousel = document.getElementById("thumbnail-carousel");
  
  if (mainCarousel && thumbnailCarousel) {
    var main = new Splide("#main-carousel", {
      type: "fade",
      rewind: true,
      pagination: false,
      arrows: false,
    });

    var thumbnails = new Splide("#thumbnail-carousel", {
      fixedWidth: 100,
      fixedHeight: 100,
      gap: 10,
      rewind: true,
      pagination: false,
      isNavigation: true,
      focus: "center",
      breakpoints: {
        600: {
          fixedWidth: 75,
          fixedHeight: 75,
        },
      },
    });

    main.sync(thumbnails);
    main.mount();
    thumbnails.mount();
  }
});

//BENTO
// Mettre en évidence le premier bouton et afficher la première section par défaut
/*document.addEventListener("DOMContentLoaded", function () {
  setActiveButtonAndSection("benefits");
});

function setActiveButtonAndSection(sectionId) {
  var sections = document.getElementsByClassName("accordion-content");
  var buttons = document.querySelectorAll(".section-btn");

  // Vérifier que la section existe
  var activeSection = document.getElementById(sectionId);
  if (!activeSection) {
    console.error(`Section ${sectionId} introuvable`);
    return; // Si la section est introuvable, arrêter l'exécution
  }

  // Réinitialiser tous les boutons et sections
  for (var i = 0; i < sections.length; i++) {
    sections[i].style.display = "none";
    buttons[i].classList.remove("scale-105", "font-black");
    buttons[i].classList.add("font-normal");
  }

  // Activer la section et le bouton correspondant
  activeSection.style.display = "flex";

  var activeButton = document.querySelector(`button[data-target="${sectionId}"]`);
  if (activeButton) {
    activeButton.classList.add("scale-105", "font-black");
    activeButton.classList.remove("font-normal");
  }
}*/



function toggleSection(sectionId) {
  setActiveButtonAndSection(sectionId);
}

document.addEventListener("DOMContentLoaded", function () {
  // Ajout d'écouteurs sur chaque input radio dans les étiquettes de variantes
  document
    .querySelectorAll('.variant-label input[type="radio"]')
    .forEach((input) => {
      input.addEventListener("change", function () {
        // Retirer la classe 'selected' de toutes les étiquettes
        document.querySelectorAll(".variant-label").forEach((label) => {
          label.classList.remove("selected");
        });
        // Ajouter la classe 'selected' à l'étiquette parente de l'input radio sélectionné
        this.closest(".variant-label").classList.add("selected");
      });
    });

  // Déclenche manuellement le changement sur le radio bouton sélectionné au chargement de la page
  const initiallyCheckedInput = document.querySelector(
    '.variant-label input[type="radio"]:checked',
  );
  if (initiallyCheckedInput) {
    initiallyCheckedInput.dispatchEvent(new Event("change"));
  }
});

document
  .querySelectorAll('.variant-label input[type="radio"]')
  .forEach((input) => {
    input.addEventListener("change", function () {
      document.querySelectorAll(".variant-label").forEach((label) => {
        label.classList.remove("selected");
      });
      this.closest(".variant-label").classList.add("selected");
    });
  });

//CART

/*document.addEventListener("DOMContentLoaded", function () {
  const cartDrawerOverlay = document.querySelector("#CartDrawer-Overlay");
  if (cartDrawerOverlay) {
    cartDrawerOverlay.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      closeDrawer(); // Corrected function name to closeDrawer
    });
  } else {
    console.error("Could not find #CartDrawer-Overlay element");
  }

  function closeDrawer() {
    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer) {
      cartDrawer.classList.remove("active");
    }
  }
});*/


//DESACTIVATE /CART

document.addEventListener("DOMContentLoaded", function () {
  const cartLinks = document.querySelectorAll('a[href="/cart"], button[data-href="/cart"]');
  cartLinks.forEach((link) => {
    link.addEventListener("click", (event) => {
      event.preventDefault(); // Empêche la redirection vers la page panier
      openCartDrawer(); // Ouvre le drawer du panier à la place
    });
  });

  function openCartDrawer() {
    const drawer = document.querySelector("cart-drawer");
    if (drawer) {
      drawer.classList.add("animate", "active");
    }
  }
});


document.body.addEventListener("submit", async (event) => {
  const form = event.target;
  if (!form.matches('form[action="/cart/add"]')) {
    // This form should not prevent default
    return;
  }

  event.preventDefault(); // Prevent the normal form submission

  const formData = new FormData(form);

  // Submit the form via AJAX
  const response = await fetch("/cart/add.js", {
    method: "post",
    body: formData,
  });

  if (response.ok) {
    updateCartDrawer(); // Update the cart drawer content
    openCartDrawer(); // Open the cart drawer
  } else {
    console.error("Failed to add item to cart:", await response.text());
  }
});

// Declare the variable in the outer scope so it's accessible to both functions
let checkButtonInterval;

function addCheckoutButtonId() {
  // Use a more specific selector
  var checkoutButton = document.querySelector(
    'button[data-ocu-checkout="true"][name="checkout"].hs-checkout-purchase.checkout-x-buy-now-btn',
  );
  if (checkoutButton) {
    checkoutButton.id = "checkoutButtonId";
    clearInterval(checkButtonInterval); // Stop the interval once the button is found and ID is set
  }
}

// Wait for the DOM content to be fully loaded
document.addEventListener("DOMContentLoaded", function () {
  // Set an interval to periodically check for the button
  checkButtonInterval = setInterval(addCheckoutButtonId, 500); // Check every 500ms
});

// Obtenez la devise du shop via l'objet Shopify
const shopCurrency = Shopify.currency.active || "USD"; // Valeur par défaut 'USD' si non disponible

// Sélection des variantes
const variantOptions = document.querySelectorAll(".variant-option");
const addToCartBtn = document.getElementById("add-to-cart-btn");
const dynamicPrice = document.getElementById("dynamic-price");

variantOptions.forEach((option) => {
  option.addEventListener("click", function () {
    // Récupérer l'ID de la variante sélectionnée et sa disponibilité
    const selectedVariantId = this.dataset.variantId;
    const selectedVariantPrice = this.dataset.price;
    const isOutOfStock = this.dataset.available === "false";

    /* Réinitialiser toutes les variantes à leur état par défaut
    variantOptions.forEach((el) => {
      el.classList.remove("bg-mediumpurple", "text-white");
      el.classList.add("bg-white", "text-darkpurple");
    });

    // Activer l'état sélectionné pour la variante cliquée
    this.classList.remove("bg-white", "text-darkpurple");
    this.classList.add("bg-mediumpurple", "text-white"); */

    // Désactiver le bouton si la variante est en rupture de stock
    if (addToCartBtn) {
      if (isOutOfStock) {
        addToCartBtn.disabled = true;
        addToCartBtn.classList.add("opacity-50", "cursor-not-allowed");
      } else {
        addToCartBtn.disabled = false;
        addToCartBtn.classList.remove("opacity-50", "cursor-not-allowed");
        addToCartBtn.dataset.variantId = selectedVariantId;

      // Mettre à jour le texte du bouton "Ajouter au panier" avec le prix sélectionné
      if (document.querySelector('[data-preorder="true"]')) {
        // Si en mode précommande, garder le texte de précommande + prix
        const preorderText = document.querySelector('[data-preorder-text]').dataset.preorderText;
        addToCartBtn.innerHTML = `${preorderText} - ${new Intl.NumberFormat(
          "en-US",
          {
            style: "currency",
            currency: shopCurrency,
          }
        ).format(selectedVariantPrice / 100)}`;
      } else {
        // Sinon, afficher le prix normalement
        addToCartBtn.textContent = `Ajouter au panier - ${new Intl.NumberFormat(
          "en-US",
          {
            style: "currency",
            currency: shopCurrency,
          }
        ).format(selectedVariantPrice / 100)}`;
      }

        // Mettre à jour le prix dynamique (affichage à côté du bouton)
        if (dynamicPrice) {
          dynamicPrice.textContent = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: shopCurrency,
          }).format(selectedVariantPrice / 100);
        }
      }
    }

    // Mettre à jour l'URL sans recharger la page
    const newUrl = `${window.location.pathname}?variant=${selectedVariantId}`;
    window.history.pushState({ path: newUrl }, "", newUrl);
  });
});


// Mettre à jour le drawer du panier
async function updateCartDrawer() {
  const response = await fetch("/?section_id=cart-drawer");
  const cartHTML = await response.text();
  const parser = new DOMParser();
  const doc = parser.parseFromString(cartHTML, "text/html");
  const newDrawer = doc.querySelector(".cart-drawer");
  const currentDrawer = document.querySelector(".cart-drawer");

  if (currentDrawer && newDrawer) {
    currentDrawer.replaceWith(newDrawer);
  }
}

// Ouvrir le drawer du panier
function openCartDrawer() {
  const drawer = document.querySelector("cart-drawer");
  if (drawer) {
    drawer.classList.add("animate", "active");
  }
}

document.addEventListener("DOMContentLoaded", function () {
  let currentImageIndex = 0;
  const mainImageMobile = document.getElementById("main-image-mobile");
  const mainImageDesktop = document.getElementById("main-image-desktop");
  const mainImage = document.getElementById("main-image");
  const thumbnails = document.querySelectorAll(".thumbnail");
  const previewThumbnails = document.querySelectorAll(".preview-thumbnail");
  const previewThumbnailsContainer = document.getElementById(
    "preview-thumbnails-container",
  );

  function updateImage(index) {
    if (thumbnails.length === 0) return; // Guard clause if no thumbnails exist
    
    currentImageIndex = index;
    const imageUrl = thumbnails[index]?.dataset.image;
    
    if (!imageUrl) return; // Guard clause if no image URL

    // Update main images if they exist
    if (mainImageMobile) {
      mainImageMobile.src = imageUrl;
    }
    
    if (mainImageDesktop) {
      mainImageDesktop.src = imageUrl;
    }

    if (mainImage) {
      mainImage.src = imageUrl;
    }

    // Remove the purple background from all thumbnails and preview thumbnails
    thumbnails.forEach((thumbnail) => thumbnail.classList.remove("bg-purple"));
    previewThumbnails.forEach((previewThumbnail) =>
      previewThumbnail.classList.remove("bg-purple"),
    );

    // Add the purple background to the selected thumbnail and preview thumbnail
    thumbnails[index].classList.add("bg-purple");
    if (previewThumbnails[index]) {
      previewThumbnails[index].classList.add("bg-purple");
    }

    // Ensure the active thumbnail is visible in the preview container
    if (previewThumbnailsContainer && previewThumbnails[index]) {
      const activeThumbnail = previewThumbnails[index];
      const thumbnailLeft = activeThumbnail.offsetLeft;
      const containerWidth = previewThumbnailsContainer.clientWidth;
      const thumbnailWidth = activeThumbnail.clientWidth;

      const scrollPosition =
        thumbnailLeft - containerWidth / 2 + thumbnailWidth / 2;
      previewThumbnailsContainer.scroll({
        left: scrollPosition,
        behavior: "smooth",
      });
    }
  }

  // Initial setup: highlight the first image by default
  if (thumbnails.length > 0) {
    updateImage(currentImageIndex);
  }

  // Event listener for the previous button
  const prevBtn = document.getElementById("prev-btn");
  if (prevBtn) {
    prevBtn.addEventListener("click", function () {
      currentImageIndex =
        currentImageIndex > 0 ? currentImageIndex - 1 : thumbnails.length - 1;
      updateImage(currentImageIndex);
    });
  }

  // Event listener for the next button
  const nextBtn = document.getElementById("next-btn");
  if (nextBtn) {
    nextBtn.addEventListener("click", function () {
      currentImageIndex =
        currentImageIndex < thumbnails.length - 1 ? currentImageIndex + 1 : 0;
      updateImage(currentImageIndex);
    });
  }

  // Event listeners for thumbnail clicks
  thumbnails.forEach((thumbnail, index) => {
    thumbnail.addEventListener("click", function () {
      updateImage(index);
    });
  });

  // Event listeners for preview-thumbnail clicks
  previewThumbnails.forEach((previewThumbnail, index) => {
    previewThumbnail.addEventListener("click", function () {
      updateImage(index);
    });
  });

  // Keyboard navigation
  document.addEventListener("keydown", function (event) {
    if (event.key === "ArrowLeft") {
      // Move to the previous image
      currentImageIndex =
        currentImageIndex > 0 ? currentImageIndex - 1 : thumbnails.length - 1;
      updateImage(currentImageIndex);
    } else if (event.key === "ArrowRight") {
      // Move to the next image
      currentImageIndex =
        currentImageIndex < thumbnails.length - 1 ? currentImageIndex + 1 : 0;
      updateImage(currentImageIndex);
    }
  });

  // Touch events for slide support (swipe gestures)
  let touchStartX = 0;
  let touchEndX = 0;

  // Add touch event listeners to both mobile and desktop images
  const handleTouchStart = function(e) {
    touchStartX = e.changedTouches[0].screenX;
  };

  const handleTouchEnd = function(e) {
    touchEndX = e.changedTouches[0].screenX;
    handleGesture();
  };

  if (mainImageMobile) {
    mainImageMobile.addEventListener("touchstart", handleTouchStart);
    mainImageMobile.addEventListener("touchend", handleTouchEnd);
  }

  if (mainImageDesktop) {
    mainImageDesktop.addEventListener("touchstart", handleTouchStart);
    mainImageDesktop.addEventListener("touchend", handleTouchEnd);
  }

  if (mainImage) {
    mainImage.addEventListener("touchstart", handleTouchStart);
    mainImage.addEventListener("touchend", handleTouchEnd);
  }

  function handleGesture() {
    if (touchEndX < touchStartX - 50) {
      // Swipe left - go to next image
      currentImageIndex =
        currentImageIndex < thumbnails.length - 1 ? currentImageIndex + 1 : 0;
      updateImage(currentImageIndex);
    } else if (touchEndX > touchStartX + 50) {
      // Swipe right - go to previous image
      currentImageIndex =
        currentImageIndex > 0 ? currentImageIndex - 1 : thumbnails.length - 1;
      updateImage(currentImageIndex);
    }
  }

  /* Variant selection and dynamic price update
  const variantOptions = document.querySelectorAll(".variant-option");

  variantOptions.forEach((option) => {
    option.addEventListener("click", function () {
      // Reset all variants to default state
      variantOptions.forEach((el) => {
        el.classList.remove("bg-mediumpurple", "text-white", "border-yellow");
        el.classList.add("bg-white", "text-darkpurple", "border-darkpurple");
      });

      // Set the clicked variant to active state
      this.classList.remove("bg-white", "text-darkpurple", "border-darkpurple");
      this.classList.add("bg-mediumpurple", "text-white", "border-yellow");

      // Update the Add to Cart button with the selected variant ID
      const selectedVariantId = this.dataset.variantId;
      const selectedVariantPrice = this.dataset.price;

      document.getElementById("add-to-cart-btn").dataset.variantId =
        selectedVariantId;
      document.getElementById("dynamic-price").textContent =
        new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "{{ shop.currency }}",
        }).format(selectedVariantPrice / 100); // Adjusting for cents
    });
  }); */

  // Add to Cart
  const addToCartBtn = document.getElementById("add-to-cart-btn");
  if (addToCartBtn) {
    addToCartBtn.addEventListener("click", function () {
      const variantId = this.dataset.variantId;
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ quantity: 1, id: variantId }),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("Added to cart:", data);
        })
        .catch((error) => console.error("Error:", error));
    });
  }

  // Accordion functionality for description, ingredients, how to take, and shipping
  const accordions = [
    { container: "description-container", content: "description-content", toggle: "toggle-description" },
    { container: "why-container", content: "why-content", toggle: "toggle-why" },
    { container: "ingredients-container", content: "ingredients-content", toggle: "toggle-ingredients" },
    { container: "satisfaction-container", content: "satisfaction-content", toggle: "toggle-satisfaction" },
    { container: "analyses-container", content: "analyses-content", toggle: "toggle-analyses" },
    { container: "shipping-container", content: "shipping-content", toggle: "toggle-shipping" },
    { container: "prep-container", content: "prep-content", toggle: "toggle-prep" }
  ];

  function closeAllAccordions() {
    accordions.forEach(function(acc) {
      const content = document.getElementById(acc.content);
      const toggleButton = document.getElementById(acc.toggle);
      if (content && toggleButton) {
        content.classList.add("hidden");
        toggleButton.textContent = "+";
      }
    });
  }

  accordions.forEach(function(accordion) {
    const container = document.getElementById(accordion.container);
    const content = document.getElementById(accordion.content);
    const toggleButton = document.getElementById(accordion.toggle);

    if (container && content && toggleButton) {
      container.addEventListener("click", function() {
        if (content.classList.contains("hidden")) {
          closeAllAccordions();
          content.classList.remove("hidden");
          toggleButton.textContent = "-";
        } else {
          content.classList.add("hidden");
          toggleButton.textContent = "+";
        }
      });
    }
  });
});

function scrollToProductInfo() {
  document
    .getElementById("product-info")
    .scrollIntoView({ behavior: "smooth" });
}
